import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Cart, CartResponse} from '../interfaces/Cart.interface';
import {MyAccountData} from '../interfaces/MyAccount.interface';
import { ApiServices } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  vehicleFormData = new BehaviorSubject(null);
  filters = new BehaviorSubject(null);
  diameter = new BehaviorSubject(null);
  searchSelections = new BehaviorSubject(null);
  checkFitment = new BehaviorSubject(false);
  fitmentData = new BehaviorSubject(null);
  isLoggedIn = new BehaviorSubject(false);
  cartData = new BehaviorSubject<Cart>(null);
  cartCount = new BehaviorSubject<number>(0);
  hideHeaderFooter = new BehaviorSubject<boolean>(false);
  myAccountData = new BehaviorSubject<MyAccountData>(null);

  dealerlogo = new BehaviorSubject<string>('/assets/img/new-logo.png');

  constructor(private apiService: ApiServices) { }

  setVehiclesData = (data, category = null) => {
    const wheel = data[0].wheels.find(x => x.is_stock);
    const vehicleData: any = {
      // centre_bore: data[0].centre_bore,
      // generation: data[0].generation.name,
      bolt_pattern: data[0].technical.bolt_pattern,
      rim_diameter: wheel.front.rim_diameter,
      // tire_aspect_ratio: data[0].wheels[0].front.tire_aspect_ratio,
      width: wheel.front.rim_width,
      // checkfitment: 'checkfitment',
      // category
    };

    this.diameter.next(wheel.front.rim_diameter);
    this.vehicleFormData.next(vehicleData);
    this.searchSelections.next(true);

  }

  // setVehiclesData = (data, category = null) => {
  //   const wheel = data[0].wheels.find(x => x.is_stock);
  //   const vehicleData: any = {
  //     // centre_bore: data[0].centre_bore,
  //     // generation: data[0].generation.name,
  //     bolt_pattern: data[0].bolt_pattern,
  //     rim_diameter: wheel.front.rim_diameter,
  //     // tire_aspect_ratio: data[0].wheels[0].front.tire_aspect_ratio,
  //     width: wheel.front.rim_width,
  //     // checkfitment: 'checkfitment',
  //     // category
  //   };

  //   this.diameter.next(wheel.front.rim_diameter);
  //   this.vehicleFormData.next(vehicleData);
  //   this.searchSelections.next(true);

  // }

  setCartData(cart: CartResponse): void {
    this.cartData.next(cart.data);
    if(cart.data) {
      let count = cart.data.count;
      this.cartCount.next(count);
    } else {
      this.cartCount.next(0);
    }
  }

  setAddOnCategories(categories: Array<any>) {
    localStorage.setItem('add_on_categories', JSON.stringify(categories));
  }

  async getAddOnCategories() {
    return new Promise((resolve, reject) => {
      const cats = localStorage.getItem('add_on_categories');

      if(cats) {
        return resolve(JSON.parse(cats));
      } else {
        this.apiService.getAddOnCategories().subscribe(response => {
          const data = response.data;
          this.setAddOnCategories(data);

          return resolve(data);
        });
      }
    });
  }
}
